__turbopack_context__.v({
  "breadCrumbs": "index-module-scss-module__iwmnEW__breadCrumbs",
  "linkButton": "index-module-scss-module__iwmnEW__linkButton",
  "mortgageWrap": "index-module-scss-module__iwmnEW__mortgageWrap",
  "rectangle": "index-module-scss-module__iwmnEW__rectangle",
  "standardContentContainer": "index-module-scss-module__iwmnEW__standardContentContainer",
});
